<template>
    <AppLayout v-bind="appSharedData.getAppSidebarLayoutProps(pageMeta)">
        <template
            v-if="appSharedData.isSuperAdmin()"
            #right
        >
            <div
                class="flex flex-col md:flex-row items-end md:items-center gap-2 w-full"
            >
                <CreateAutomationButtonDrawer />
            </div>
        </template>

        <div>
            <div class="grid grid-cols-12 gap-4">
                <template
                    v-for="automation in localAutomations"
                    :key="automation.id.value"
                >
                    <div class="col-span-12 lg:col-span-6">
                        <AutomationCard
                            :isSuperAdmin="appSharedData.isSuperAdmin()"
                            :automation="automation"
                            @onAutomationUpdated="
                                handleAutomationUpdate($event.automation)
                            "
                            @onAutomationDeleted="
                                handleAutomationDeleted(automation.id)
                            "
                        />
                    </div>
                </template>
            </div>
        </div>

        <div>
            <Pagination
                :searchResults="automationsPaginatedData"
                :url="urlFactory.makeAutomationsUrl(searchFilters.perPage)"
            />
        </div>
    </AppLayout>
</template>

<script setup lang="ts">
    import { UrlFactory } from '@/Shared/Url/UrlFactory'
    import { ref } from 'vue'
    import AppLayout from '@/Shared/Layout/App/Sidebar/AppLayout.vue'
    import {
        type AutomationSearchFiltersType,
        type PageMeta,
        type PaginatedResultsType,
    } from '@/Shared/AutoGenerated/Main'
    import AppSharedData from '@/Shared/Entity/AppSharedData'
    import Automation from '@/App/Automation/Entity/Automation'
    import AutomationCard from '@/App/Automation/Component/AutomationCard.vue'
    import CreateAutomationButtonDrawer from '@/App/Automation/Component/CreateAutomationButtonDrawer.vue'
    import Pagination from '@/Shared/Component/Pagination.vue'
    import AutomationID from '@/App/Automation/Entity/AutomationID'

    interface IndexServicesProps {
        pageMeta: PageMeta
        appSharedDataRawData: any
        automationsPaginatedData: PaginatedResultsType
        searchFilters: AutomationSearchFiltersType
    }

    const props = defineProps<IndexServicesProps>()
    const appSharedData = AppSharedData.hydrate(props.appSharedDataRawData)
    const localAutomations = ref<Automation[]>(
        Automation.hydrateMultiple(props.automationsPaginatedData.records),
    )

    const handleAutomationUpdate = (updatedAutomation: Automation) => {
        localAutomations.value = localAutomations.value.map((automation) => {
            return automation.id.value !== updatedAutomation.id.value
                ? automation
                : updatedAutomation
        })
    }

    const handleAutomationDeleted = (automationId: AutomationID) => {
        localAutomations.value = localAutomations.value.filter((automation) => {
            return automation.id.value !== automationId.value
        })
    }
    const urlFactory = new UrlFactory()
</script>
